import type { ServiceType } from '@econtractor/types';
import { useAuth } from 'context/AuthContext';
import { hasUserAccess } from 'utils/helpers/access/hasUserAccess';
import EmptyResult from 'components/others/EmptyResult';
import ServiceTableRow from './ServiceTableRow';
import { useService } from './context/ServiceProvider';

interface ServiceTableBodyProps {
    servicesList: ServiceType[];
    fetchServices: (force?: boolean) => Promise<unknown>;
}

const ServiceTableBody = ({ servicesList, fetchServices }: ServiceTableBodyProps) => {
    const { auth } = useAuth();
    const { showUpdated } = useService();
    const colSpan = 6
        + (showUpdated ? 1 : 0)
        + (hasUserAccess(auth?.user, 'prodEdit') ? 1 : 0);

    return (
        <tbody>
            {servicesList?.map((service) => (
                <ServiceTableRow key={service.ID} service={service} fetchServices={fetchServices} />
            ))}

            {servicesList.length === 0 && (
                <tr>
                    <td colSpan={colSpan}>
                        <EmptyResult />
                    </td>
                </tr>
            )}
        </tbody>
    );
};

export default ServiceTableBody;
